import React from 'react';
import DataVersionDisplay from '../DataVersion/DataVersionDisplay';

const Downloads = () => {
  return(
  <div className="bg-slate-200 py-6 flex flex-col justify-center relative overflow-hidden sm:py-12">
       <span className="border text-4xl text-blue-400 px-6 pt-10 pb-8 bg-white w-1/2 max-w-md mx-auto rounded-t-md sm:px-10">Download Data</span>
      <div className="border relative px-4 pt-7 pb-8 bg-white shadow-xl w-1/2 max-w-md mx-auto sm:px-10 rounded-b-md">

      Introduction<br/>
      <br/>
      How to use<br/>
      <br/>
      Login<br/>
      <br/>
      <div className="mb-3">
        <DataVersionDisplay variant="inline" dataType="taxdata_download" />
      </div>
      <p className='btn'><a href="/download-data-filter-form" className="text-light">Get Data</a></p>
      </div>
      </div>
  )
}

export default Downloads